<template>
  <div class="share-qrcode">
    <div>
      <div v-if="false" @click="onClick">点这里点这里点这里</div>
      <div :style="dynamicQrcodeDivStyle1">
        <div id="qrCode" ref="qrCodeDiv" :style="dynamicQrcodePositionStyle" v-if="hasQrCodeUrlText"></div>
        <div :style="dynamicNoQrcodePositionStyle" v-else>
          <img :src="require('@/assets/qrcode-no-img.png')" alt="" />
        </div>
        <div :style="dynamicButtonPositionStyle" @click="handleShareBtnEvent"></div>
      </div>
      <div :style="dynamicQrcodeDivStyle2">
        <div class="explain-text" v-html="explainTextHtml"></div>
      </div>
    </div>
  </div>
</template>

<script>
/* global
    PUBLIC_PRODUCT,
    PUBLIC_SHARE_QRCODE_EXPLAIN_TEXT,
    PUBLIC_HF_PLUS_SHARE_URL,
    wx
 */

import QRCode from 'qrcodejs2';
import { CusToast } from '@/utils/CustomToast';
import { Indicator } from 'mint-ui';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { GetThirdPartyInviteUrlOfZs, GetThirdPartyInviteUrlOfZd } from '@/api/user';

export default {
  name: 'ShareQrCode',
  data() {
    return {
      hasQrCodeUrlText: true,
      screenWidth: window.screen.width,
      div1BgImgW: 750,
      div1BgImgH: 1129,
      div1BgImgPath: require('@/assets/share_qrcode_bg1_1.png'),
      div2BgImgPath: require('@/assets/share_qrcode_bg1_2.png'),
      qrCodeStyle: {
        colorDark: '#000',
        colorLight: '#fff',
      },
      explainTextHtml: PUBLIC_SHARE_QRCODE_EXPLAIN_TEXT,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (PUBLIC_HF_PLUS_SHARE_URL) this.createQrCodeByFromParam();
      else this.createQrCodeFromInterface();
    });
  },
  computed: {
    dynamicQrcodeDivStyle1() {
      // alert(window.screen.width);
      const bgWidth = this.screenWidth;
      // alert(`width:${this.screenWidth};height:${this.screenHeight}`);
      const bgHeight = this.div1BgImgH * (bgWidth / this.div1BgImgW);
      return `width:${bgWidth}px;height:${bgHeight}px;background-image:url(${this.div1BgImgPath});background-repeat:no-repeat;background-size:100% 100%;position:relative;`;
    },
    dynamicQrcodeDivStyle2() {
      return `width:${this.screenWidth}px;background-image:url(${this.div2BgImgPath});background-repeat:repeat-y;background-size:100%;`;
    },
    dynamicQrcodePositionStyle() {
      let top = 0;
      let left = 0;
      switch (this.screenWidth) {
        case 320:
          top = 253;
          left = 106;
          break;
        case 360:
          top = 284;
          left = 119;
          break;
        case 375:
          top = 297;
          left = 125;
          break;
        case 411:
        case 412:
          top = 325;
          left = 136;
          break;
        case 414:
          top = 328;
          left = 138;
          break;
        case 480:
          top = 380;
          left = 160;
          break;
      }
      return `position:absolute;top:${top}px;left:${left}px;`;
    },
    dynamicNoQrcodePositionStyle() {
      let top = 0;
      let left = 0;
      let width = 100;
      let height = 100;
      switch (this.screenWidth) {
        case 320:
          top = 253;
          left = 106;
          width = 111;
          height = 111;
          break;
        case 360:
          top = 284;
          left = 119;
          width = 125;
          height = 125;
          break;
        case 375:
          top = 297;
          left = 125;
          width = 129;
          height = 129;
          break;
        case 411:
        case 412:
          top = 325;
          left = 136;
          width = 143;
          height = 143;
          break;
        case 414:
          top = 328;
          left = 138;
          width = 142;
          height = 142;
          break;
        case 480:
          top = 380;
          left = 160;
          width = 165;
          height = 165;
          break;
      }
      return `width:${width}px;height:${height}px;position:absolute;top:${top}px;left:${left}px;`;
    },
    dynamicButtonPositionStyle() {
      let top = 0;
      let left = 0;
      let width = 100;
      let height = 100;
      switch (this.screenWidth) {
        case 320:
          top = 396;
          left = 94;
          width = 134;
          height = 41;
          break;
        case 360:
          top = 446;
          left = 106;
          width = 151;
          height = 44;
          break;
        case 375:
          top = 464;
          left = 111;
          width = 157;
          height = 48;
          break;
        case 411:
        case 412:
          top = 509;
          left = 121;
          width = 172;
          height = 51;
          break;
        case 414:
          top = 512;
          left = 122;
          width = 173;
          height = 52;
          break;
        case 480:
          top = 594;
          left = 142;
          width = 200;
          height = 60;
          break;
      }
      return `width:${width}px;height:${height}px;position:absolute;top:${top}px;left:${left}px;`;
    },
    dynamicQrcodeWidth() {
      let resultWidth = null;
      switch (this.screenWidth) {
        case 320:
          resultWidth = 111;
          break;
        case 360:
          resultWidth = 125;
          break;
        case 375:
          resultWidth = 129;
          break;
        case 411:
        case 412:
          resultWidth = 143;
          break;
        case 414:
          resultWidth = 142;
          break;
        case 480:
          resultWidth = 165;
          break;
        default:
          resultWidth = 165;
          break;
      }
      return resultWidth;
    },
    dynamicQrcodeHeight() {
      let resultHeight = null;
      switch (this.screenWidth) {
        case 320:
          resultHeight = 111;
          break;
        case 360:
          resultHeight = 125;
          break;
        case 375:
          resultHeight = 129;
          break;
        case 411:
        case 412:
          resultHeight = 143;
          break;
        case 414:
          resultHeight = 142;
          break;
        case 480:
          resultHeight = 165;
          break;
      }
      return resultHeight;
    },
  },
  methods: {
    createQrCodeByFromParam() {
      new QRCode(this.$refs.qrCodeDiv, {
        text: decodeURIComponent(PUBLIC_HF_PLUS_SHARE_URL),
        width: this.dynamicQrcodeWidth,
        height: this.dynamicQrcodeHeight,
        colorDark: this.qrCodeStyle.colorDark,
        colorLight: this.qrCodeStyle.colorLight,
        correctLevel: QRCode.CorrectLevel.L,
      });
      wx.miniProgram.postMessage({ data: PUBLIC_HF_PLUS_SHARE_URL });
    },
    createQrCodeFromInterface() {
      Indicator.open();
      let GetThirdPartyInviteUrl = null;
      switch (PUBLIC_PRODUCT.toLowerCase().trim()) {
        case 'yft':
        case 'cxyf':
        case 'cxpro':
        case 'cxplus':
        case 'hfplus':
          GetThirdPartyInviteUrl = GetThirdPartyInviteUrlOfZd;
          break;
        case 'yftzs':
        case 'cxyfzs':
        case 'cxpluszs':
        case 'hfpluszs':
        case 'xhgj':
          GetThirdPartyInviteUrl = GetThirdPartyInviteUrlOfZs;
          break;
        default:
          GetThirdPartyInviteUrl = GetThirdPartyInviteUrlOfZs;
          break;
      }
      GetThirdPartyInviteUrl()
        .then(res => {
          Indicator.close();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              new QRCode(this.$refs.qrCodeDiv, {
                text: res.data.url,
                width: this.dynamicQrcodeWidth,
                height: this.dynamicQrcodeHeight,
                colorDark: this.qrCodeStyle.colorDark,
                colorLight: this.qrCodeStyle.colorLight,
                correctLevel: QRCode.CorrectLevel.L,
              });
              wx.miniProgram.postMessage({ data: encodeURIComponent(res.data.url) });
            },
            (err_code, err_msg) => {
              if (err_code === 1) this.hasQrCodeUrlText = false;
              else CusToast(err_msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    handleShareBtnEvent() {
      window.location.href = 'share://android';
    },
    onClick() {
      window.location.href = 'http://ledgerapi.yftepay.com/a.html';
    },
  },
};
</script>
